module.exports = __webpack_public_path__ + "img/meinMVP.6f0a958b.webp";